<template>
  <div class="main-view" v-loading.body="loading">
    <el-card class="searchCard" shadow="never">
      <!-- 筛选 -->
      <el-col>
        <el-form inline class="inline-form">
          <el-form-item label="分润时间">
            <date-range-picker v-model="creatTime" type="daterange" :value="creatTime" ref="creatTime" @getChange="dateChange"></date-range-picker>
          </el-form-item>
          <el-form-item label="下级代理商">
            <el-select
              class="search-input"
              v-model="subAgentId"
              placeholder="模糊搜索"
              clearable
              filterable
              :filter-method="handleAgentInfoFilter">
              <el-option
                style="width:200px;"
                v-for="item in subAgentInfoList"
                :key="item.fAgentId"
                :label="item.fAgentId"
                :value="item.fAgentId">
                <span class="value">{{ item.fAgentId }}</span>
                <span class="name">{{ item.fTitle }}</span>
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="发展业务员">
            <el-select
              class="search-input"
              v-model="operatorAccount"
              placeholder="模糊搜索"
              clearable
              filterable
              :filter-method="handleSalesInfoFilter"
              :disabled="roleName == 'operator'">
              <el-option
                v-for="item in saleInfoList"
                :key="item.fAgentAccount"
                :label="item.fAgentAccount"
                :value="item.fAgentId">
                <span class="value">{{ item.fAgentAccount }}</span>
                <span class="name">{{ item.fName }}</span>
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <auth-button opt="search" :plain="true" icon="el-icon-search" @click.native="searchClick" label="查询"></auth-button>
            <auth-button
              opt="export"
              icon="el-icon-download"
              type="primary"
              :plain="true"
              :loading="exportButtonLoading"
              @click.native="exportClick"
              label="导出"></auth-button>
          </el-form-item>
        </el-form>
      </el-col>
      <!-- 汇总 -->
      <el-col>
        <div class="sum-view">
          <div>
            <div class="sum-item-title">分润总额</div>
            <div>{{ totalInfo.totalAgentProfitAmountStr }}</div>
          </div>
          <div>
            <div class="sum-item-title">直属商户交易分润</div>
            <div>{{ totalInfo.directMerchantDealProfitStr }}</div>
          </div>
          <div>
            <div class="sum-item-title">非直属商户交易分润</div>
            <div>{{ totalInfo.subAgentMerchantDealProfit }}</div>
          </div>
          <div>
            <div class="sum-item-title">额外收取下级分成分润</div>
            <div>{{ totalInfo.extraSubAgentTotalProfitStr }}</div>
          </div>
          <div>
            <div class="sum-item-title">应分下级分润</div>
            <div>{{ totalInfo.subAgentTotalProfitStr }}</div>
          </div>
        </div>
      </el-col>
      <el-col>
        <div class="search-tips">说明：目前查询仅展示最近6个月数据，导出最大支持100000条数据</div>
      </el-col>
    </el-card>
    <el-card class="tableCard" shadow="never">
      <!-- table -->
      <el-table
        stripe
        style="width:100%;"
        v-loading="tableLoading"
        :data="profitSummaryList"
        :header-cell-style="{background:'#FAFAFA'}">
        <el-table-column
          prop="fagentId"
          label="下级代理商"
          align="center"
          min-width="200">
        </el-table-column>
        <el-table-column
          prop="fagentTitle"
          label="下级代理商名称"
          align="center"
          min-width="200">
        </el-table-column>
        <el-table-column
          prop="operatorAccount"
          label="发展业务员"
          align="center"
          min-width="200">
          <template slot-scope="scope">
            <div>{{ scope.row.operatorAccount || '--' }}</div>
          </template>
        </el-table-column>
        <el-table-column
          prop="agentProfitAmountStr"
          label="分润总额"
          align="center"
          min-width="150">
        </el-table-column>
        <el-table-column
          prop="nonDirectMerchantProfitStr"
          label="非直属商户交易分润"
          align="center"
          min-width="150">
        </el-table-column>
        <el-table-column
          prop="extraSubAgentProfitStr"
          label="额外收取下级分成分润"
          align="center"
          min-width="150">
        </el-table-column>
        <el-table-column
          prop="subAgentProfitStr"
          label="应分下级分润"
          align="center"
          min-width="150">
        </el-table-column>
      </el-table>
    </el-card>
    <pagination @changePage="onChangeCurrentPage" :count="paginations.count" :page-no="paginations.pageNo"></pagination>
  </div>
</template>

<script>
import qs from 'qs'
import { parseTime } from '@/utils/formatTime'
import dateRangePicker from '@/components/dateRangePicker'
import pagination from '@/components/pagination'
import { querySale } from '@/api/partner'
import { directSubAgentInfo } from '@/api/transaction'
import { countAgentProfit, exportCountAgentProfit } from '@/api/settle'
export default {
  name: 'ProfitSummary',
  components: {
    dateRangePicker,
    pagination
  },
  data () {
    const todayStr = (parseTime(new Date(), '{y}-{m}-{d}'))
    const toadyZero = new Date(new Date().getTime() - 3600 * 1000 * 24 * 30 * 6)
    const todayZeroStr = parseTime(toadyZero, '{y}-{m}-{d}')
    return {
      loading: false,
      // 需要给分页组件传的信息
      paginations: {
        pageNo: 1,
        count: 0,
        pageSize: 20
      },
      // 搜索表单信息
      searchInfo: {
        startTime: '',
        endTime: '',
        agentId: '',
        operatorAccount: ''
      },
      creatTime: [todayZeroStr, todayStr],
      subAgentId: '',
      operatorAccount: '',
      tableLoading: false,
      exportButtonLoading: false,
      subAgentInfoList: [],
      subAgentInfoList_back: [],
      saleInfoList: [],
      saleInfoList_back: [],
      profitSummaryList: [],
      totalInfo: {}
    }
  },
  mounted () {
    this.getDefaultData()
    if (this.roleName !== 'operator') {
      this.getSubAgentInfo()
      this.querySaleList()
    }
    console.log(this.creatTime)
  },
  beforeDestroy () {},
  methods: {
    /**
     * @description 初始加载数据方法
     */
    async getDefaultData () {
      this.loading = true
      // await this.getAllSubMerchantNames()
      await this.searchClick()
      this.loading = false
    },
    /**
     * @description 改变当前页事件
     * @param  {number} page 当前页码
     */
    onChangeCurrentPage (page) {
      this.paginations.pageNo = page
      this.searchClick(true)
    },
    /**
     * @description 筛选查询按钮点击
     */
    searchClick (noReset) {
      console.log('查询点击')
      this.setSearchInfoParams(noReset)
      this.queryCountAgentProfit()
    },
    /**
     * 导出按钮点击
     */
    exportClick () {
      console.log('导出点击')
      this.setSearchInfoParams(true)
      // const startDate = new Date(this.searchInfo.startTime)
      // const endDate = new Date(this.searchInfo.endTime)
      // if (!this.searchInfo.startTime || !this.searchInfo.endTime || endDate.getTime() - startDate.getTime() > 3600 * 1000 * 24 * 30) {
      if (!this.searchInfo.startTime || !this.searchInfo.endTime) {
        this.$message({
          // message: '请筛选1个月内的数据进行导出',
          message: '请筛选时间进行导出',
          type: 'error'
        })
        return
      }
      this.exportCountAgentProfit()
    },
    /**
     * 组装筛选参数
     */
    setSearchInfoParams (noReset) {
      this.searchInfo.startTime = this.creatTime && this.creatTime[0] ? this.creatTime[0] : ''
      this.searchInfo.endTime = this.creatTime && this.creatTime[1] ? this.creatTime[1] : ''
      this.searchInfo.agentId = this.subAgentId || ''
      this.searchInfo.operatorAccount = this.operatorAccount.replace(/ /g, '') || ''
      this.formatParams(this.searchInfo)
      if (noReset !== true) {
        this.paginations.pageNo = 1
        this.paginations.count = 0
      }
      Object.assign(this.searchInfo, this.paginations)
    },
    /**
     * @description 删除提交参数中的空字段
     * @param {Object} params 搜索内容对象
     */
    formatParams (params) {
      for (const key in params) {
        // eslint-disable-next-line no-prototype-builtins
        if (params.hasOwnProperty(key) && !params[key] && params[key] !== 0) {
          delete params[key]
        }
      }
    },
    /**
     * @description 直属代理商根据输入内容返回输入建议的方法
     * @param {String} queryString 内容字符串
     * @param {Function} cb 回调函数，接收搜索结果数据
     */
    async querySubAgentSearch (queryString, cb) {
      if (this.subAgentInfoList.length === 0) {
        await this.getSubAgentInfo()
      }
      const userInfo = JSON.parse(localStorage.getItem('ZZGAgentUser')).userEntity
      const agentList = [{
        value: userInfo.fAgentId,
        name: userInfo.fName
      }]
      this.subAgentInfoList.forEach(element => {
        agentList.push({
          value: element.fAgentId,
          name: element.fName
        })
      })
      const results = queryString ? agentList.filter(this.createSubAgentFilter(queryString)) : agentList
      cb(results)
    },
    /**
     * @description 根据输入内容进行筛选方法
     * @param {String} queryString 内容字符串
     */
    createSubAgentFilter (queryString) {
      return (agentList) => {
        return (agentList.value.toLowerCase().indexOf(queryString.toLowerCase()) !== -1) || (agentList.name.indexOf(queryString) !== -1)
      }
    },
    /**
     * 直属代理商自定义筛选方法
     */
    handleAgentInfoFilter (queryString) {
      if (queryString) {
        this.subAgentInfoList = this.subAgentInfoList_back.filter(item => {
          return item.fAgentId.toLowerCase().includes(queryString.toLowerCase()) || item.fTitle.toLowerCase().includes(queryString.toLowerCase())
        })
      } else {
        this.subAgentInfoList = this.subAgentInfoList_back
      }
    },
    /**
     * 业务员账号自定义筛选方法
     */
    handleSalesInfoFilter (queryString) {
      if (queryString) {
        this.saleInfoList = this.saleInfoList_back.filter(item => {
          return item.fAgentAccount.toLowerCase().includes(queryString.toLowerCase()) || item.fName.toLowerCase().includes(queryString.toLowerCase())
        })
      } else {
        this.saleInfoList = this.saleInfoList_back
      }
    },
    /**
     * @description 获取下级代理商下拉列表
     */
    getSubAgentInfo () {
      return new Promise((resolve, reject) => {
        // 设一个超大的pageSize取所有数据
        directSubAgentInfo('pageSize=655350').then(response => {
          console.log('getDirectSubAgentInfo response:', response)
          if (response.error_code === '0') {
            const userInfo = JSON.parse(localStorage.getItem('ZZGAgentUser')).userEntity
            const agentList = [{
              fAgentId: userInfo.fAgentId,
              fTitle: userInfo.fTitle
            }]
            this.subAgentInfoList = agentList.concat(response.list)
            this.subAgentInfoList_back = [...this.subAgentInfoList]
            resolve()
          } else {
            this.loading = false
            this.$message({
              message: response.error_msg,
              type: 'error'
            })
          }
        }).catch(() => {
          this.loading = false
        })
      })
    },
    /**
     * 获取业务员下拉列表
     */
    querySaleList () {
      return new Promise((resolve, reject) => {
        // 设一个超大的pageSize取所有数据
        querySale('pageSize=65535').then(response => {
          console.log('querySale response:', response)
          if (response.error_code === '0') {
            this.saleInfoList = response.list
            this.saleInfoList_back = [...this.saleInfoList]
            resolve()
          } else {
            this.loading = false
            this.$message({
              message: response.error_msg,
              type: 'error'
            })
          }
        }).catch(() => {
          this.loading = false
        })
      })
    },
    /**
     * 分润汇总查询
     */
    queryCountAgentProfit () {
      this.loading = true
      const params = qs.stringify(this.searchInfo)
      console.log(params)
      return new Promise((resolve, reject) => {
        countAgentProfit(params).then(response => {
          console.log('countAgentProfit response:', response)
          this.loading = false
          if (parseInt(response.result_cde) === 0) {
            this.profitSummaryList = response.list
            this.totalInfo = {
              totalAgentProfitAmountStr: response.totalAgentProfitAmountStr,
              subAgentTotalProfitStr: response.subAgentTotalProfitStr,
              subAgentMerchantDealProfit: response.subAgentMerchantDealProfit,
              directMerchantDealProfitStr: response.directMerchantDealProfitStr,
              extraSubAgentTotalProfitStr: response.extraSubAgentTotalProfitStr
            }
            this.paginations.count = response.totalCount
            if (parseInt(this.paginations.count) > 10000) {
              this.$message({
                message: '最多筛选出10000条数据，请重新筛选',
                type: 'warning'
              })
            }
            resolve()
          } else {
            this.$message({
              message: response.result_msg,
              type: 'error'
            })
          }
        })
      })
    },
    /**
     * 分润汇总导出
     */
    exportCountAgentProfit () {
      this.exportButtonLoading = true
      const params = qs.stringify(Object.assign({}, this.searchInfo, {
        moduleCode: 4,
        moduleName: '分润',
        menuName: '分润汇总'
      }))
      console.log(params)
      exportCountAgentProfit(params).then(response => {
        this.exportButtonLoading = false
        if (parseInt(response.result_cde) === 0) {
          this.$message({
            message: '导出成功，请大约1min后在下载中心中查看并下载',
            type: 'success'
          })
        } else {
          this.$message({
            message: response.result_msg,
            type: 'error'
          })
        }
      })
    },
    dateChange (value) {
      this.creatTime = value
    }
  },
  computed: {
    roleName () {
      return this.$store.getters.roleName
    }
  },
  filters: {}
}
</script>

<style scoped>
.main-view {
  padding-left: 16px;
}
.search-input {
  width: 160px;
}
.btm-action {
  margin: 20px 0;
  text-align: center;
}
.sum-view {
  margin: 10px;
  text-align: center;
  font-size: 14px;
  display: flex;
  justify-items: center;
  justify-content: space-around;
}
.sum-item-title {
  font-weight: 700;
  margin-bottom: 30px;
}
.tip-view {
  margin: 10px;
  font-size: 14px;
}
</style>
